<div class="flex">
  <div *ngFor="let icon of iconList.icons">
    <tsq-icon-picker-item [color]="color"
                          [icon]="icon"
                          (iconChange)="onIconSelected($event)"></tsq-icon-picker-item>
  </div>
</div>
